"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var TouchRecorder = function () {
  function t() {
    this.touchData = new Map(), this.gapBridgingScalingFactor = 1;
  }

  return t.prototype.getById = function (t) {
    return this.touchData.get(t);
  }, t.prototype.setBridgeGapThresholdScalingFactor = function (t) {
    this.gapBridgingScalingFactor = t;
  }, t.prototype.setGapBridgingConfig = function (t) {
    this.gapBridgingConfig = t;
  }, t.prototype.data = function () {
    return this.touchData;
  }, t.prototype.size = function () {
    return this.touchData.size;
  }, t.prototype.clear = function () {
    this.touchData.clear();
  }, t.prototype.addTouches = function (t, i) {
    if (this.gapBridgingConfig && this.gapBridgingConfig.enabled) {
      var o = this.findClosestTouchEntriesId(i[0]);

      if (o) {
        var a = this.touchData.get(o),
            n = this.concatenateTouchEntries(a, i);
        return this.touchData.set(t, n), void (t !== o && this.touchData.delete(o));
      }

      this.touchData.set(t, i);
    } else this.touchData.set(t, i);
  }, t.prototype.findClosestTouchEntriesId = function (r) {
    var c,
        g,
        s = this;
    return this.touchData.forEach(function (t, i) {
      if (!(t.length < 1)) {
        var o = t[t.length - 1];

        if ("end" === o.event) {
          var a = Math.abs(o.x - r.x),
              n = Math.abs(o.y - r.y),
              e = r.timestamp - o.timestamp;
          !s.gapBridgingConfig || a > s.gapBridgingConfig.maxXGap * s.gapBridgingScalingFactor || n > s.gapBridgingConfig.maxXGap * s.gapBridgingScalingFactor || e < 0 || e > s.gapBridgingConfig.maxTimeGap || (void 0 === g || e < g) && (c = i, g = e);
        }
      }
    }), c;
  }, t.prototype.concatenateTouchEntries = function (t, i) {
    return t.concat(i);
  }, t;
}();

exports.TouchRecorder = TouchRecorder;